import { useEffect, useRef, useState } from 'react';

export const useDrag = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [pointerPressed, setPointerPressed] = useState(false);
  const [startPosition, setStartPosition] = useState(null);
  const dragTimerRef = useRef(null);

  const pointerPressedRef = useRef(false);
  const startPositionRef = useRef(null);

  const handleDragStart = (e) => {
    clearTimeout(dragTimerRef.current);
    setStartPosition({ x: e.screenX, y: e.screenY });
    setPointerPressed(true);
  };

  const handleDragEnd = () => {
    setPointerPressed(false);
    setIsDragging(false);
    setStartPosition(null);
  };

  const handleDrag = (e) => {
    if (!startPositionRef.current || !pointerPressedRef.current) return;
    if (e.screenX !== startPositionRef.current.x || e.screenY !== startPositionRef.current.y) setIsDragging(true);
  };

  useEffect(() => {
    startPositionRef.current = startPosition;
  }, [startPosition]);

  useEffect(() => {
    pointerPressedRef.current = pointerPressed;
  }, [pointerPressed]);

  useEffect(() => {
    window.addEventListener('pointerdown', handleDragStart);
    window.addEventListener('pointerup', handleDragEnd);
    window.addEventListener('pointermove', handleDrag);
    return () => {
      window.removeEventListener('pointerdown', handleDragStart);
      window.removeEventListener('pointerup', handleDragEnd);
      window.removeEventListener('pointermove', handleDrag);
    };
  }, []);

  return isDragging;
};
